import React, { useState, useEffect, useMemo } from 'react'
import api from '@utils/api'
import { Texto, GraviGrid } from '@gravitate-js/excalibrr'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { useUserSettings } from '@hooks/settings'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'load-number-overrides'

export const LoadNumberOverrides = () => {
  const [rowData, setRowData] = useState()

  const getLoadNumberOverrides = () => {
    api.getLoadNumbersOverrides().then((resp) => {
      setRowData(resp.data.load_number_overrides)
    })
  }
  useEffect(() => {
    getLoadNumberOverrides()
  }, [])
  const { updateSetting } = useUserSettings()

  const agPropOverrides = useMemo(
    () => ({
      getRowId: (row) => row?.data?.id,
      frameworkComponents: {
        loadNumberCellRenderer: LoadNumberCellRenderer,
        missingValueCellRenderer: MissingValueCellRenderer,
      },
    }),
    []
  )
  const columnDefs = useMemo(getColumnDefs, [])

  return (
    <GraviGrid
      controlBarProps={{
        title: 'Load Number Overrides',
        actionButtons: (
          <UploadDownloadButtons
            refreshCallback={getLoadNumberOverrides}
            downloadEP={api.downloadLoadNumberOverrides}
            uploadEP={api.uploadLoadNumberOverrides}
            fileName='Load Number Overrides.xlsx'
          />
        ),
      }}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
      storageKey={STORAGE_KEY}
      rowData={rowData}
      onGridConfigChanged={(config) => updateSetting(`gridConfig::${STORAGE_KEY}`, config)}
      {...gridViewManager(STORAGE_KEY, updateSetting)}
    />
  )
}

const getColumnDefs = () => [
  {
    headerName: 'Load Number',
    field: 'load_number',
    cellRenderer: 'loadNumberCellRenderer',
  },
  {
    headerName: 'LN Supplier',
    field: 'load_number_supplier',
    enableRowGroup: true,
  },
  {
    headerName: 'Notes',
    field: 'notes',
    cellRenderer: 'missingValueCellRenderer',
  },
  {
    headerName: 'Supplier',
    field: 'supplier',
    enableRowGroup: true,
  },
  {
    headerName: 'Terminal',
    field: 'terminal',
    enableRowGroup: true,
  },
  {
    headerName: 'Supply Type',
    field: 'supply_type',
    enableRowGroup: true,
  },
  {
    headerName: 'Carrier',
    field: 'carrier',
    enableRowGroup: true,
    cellRenderer: 'missingValueCellRenderer',
  },
  {
    headerName: 'Product',
    field: 'product',
    enableRowGroup: true,
  },
  {
    headerName: 'State',
    field: 'destination_state',
    enableRowGroup: true,
  },
]

const LoadNumberCellRenderer = (loadNumber) => {
  return <Texto weight='bold'>{loadNumber.value}</Texto>
}

const MissingValueCellRenderer = ({ value }) => {
  return <Texto>{value || 'N/A'}</Texto>
}
